<div
  class="form-control-container"
  [ngStyle]="{ visibility: !attachedToShadowDom() ? 'hidden' : 'visible' }"
>
  <label class="form-control-label" for="inputRangePicker" #tooltipWrapper>
    <span>{{ isRequired ? label + ' *' : label }}</span>
    @if(infoIcon) {
    <span
      [ngStyle]="{ display: 'inline-flex', cursor: 'pointer' }"
      [pTooltip]="tooltipMessage"
      [appendTo]="tooltipWrapper"
      positionLeft="53"
      positionTop="-5"
      tooltipPosition="top"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
      >
        <g clip-path="url(#clip0_592_3470)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5ZM0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6ZM6.12906 4.01216C5.8963 3.97223 5.65692 4.01597 5.45332 4.13563C5.24972 4.25529 5.09504 4.44314 5.01667 4.66592C4.92503 4.92642 4.63957 5.0633 4.37908 4.97167C4.11858 4.88003 3.9817 4.59457 4.07333 4.33408C4.23007 3.88852 4.53943 3.51282 4.94664 3.2735C5.35384 3.03418 5.8326 2.9467 6.29812 3.02655C6.76364 3.1064 7.18588 3.34843 7.49005 3.70976C7.79416 4.07103 7.96064 4.52824 7.96 5.00046C7.95977 5.76563 7.39247 6.27095 6.98735 6.54103C6.76953 6.68624 6.55528 6.79301 6.39744 6.86316C6.31782 6.89855 6.25077 6.9254 6.20245 6.94381C6.17825 6.95303 6.15863 6.96017 6.14435 6.96525L6.12699 6.97133L6.12145 6.97322L6.11951 6.97388L6.11874 6.97413C6.11859 6.97418 6.11811 6.97434 5.96 6.5L6.11811 6.97434C5.85614 7.06167 5.57298 6.92009 5.48566 6.65811C5.39836 6.39623 5.53982 6.11317 5.80162 6.02575L5.80934 6.02303C5.81703 6.0203 5.82964 6.01572 5.84646 6.00932C5.88017 5.99647 5.93031 5.97645 5.99131 5.94934C6.11472 5.89449 6.27547 5.81376 6.43265 5.70897C6.77745 5.47911 6.96 5.23457 6.96 5L6.96 4.99926C6.96035 4.7631 6.87711 4.53443 6.72503 4.35376C6.57294 4.1731 6.36182 4.05208 6.12906 4.01216ZM5.5 8.5C5.5 8.22386 5.72386 8 6 8H6.005C6.28114 8 6.505 8.22386 6.505 8.5C6.505 8.77614 6.28114 9 6.005 9H6C5.72386 9 5.5 8.77614 5.5 8.5Z"
            fill="#5D6983"
          />
        </g>
        <defs>
          <clipPath id="clip0_592_3470">
            <rect width="12" height="12" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </span>
    }
  </label>
  <div class="datepicker-wrapper">
    <input
      id="inputRangePicker"
      [ngClass]="{
        'invalid-state':
          dateControl.hasError('endDateRequired') && !popoverOpened
      }"
      [placeholder]="placeholder"
      [(ngModel)]="inputValue"
      [readonly]="true"
      (click)="openDatePicker($event, op)"
      class="form-control-field"
      pInputText
    />
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="datepicker-icon"
      aria-hidden="true"
    >
      <path
        d="M10.7838 1.51351H9.83783V0.567568C9.83783 0.417039 9.77804 0.272676 9.6716 0.166237C9.56516 0.0597971 9.42079 0 9.27027 0C9.11974 0 8.97538 0.0597971 8.86894 0.166237C8.7625 0.272676 8.7027 0.417039 8.7027 0.567568V1.51351H5.29729V0.567568C5.29729 0.417039 5.2375 0.272676 5.13106 0.166237C5.02462 0.0597971 4.88025 0 4.72973 0C4.5792 0 4.43484 0.0597971 4.3284 0.166237C4.22196 0.272676 4.16216 0.417039 4.16216 0.567568V1.51351H3.21621C2.66428 1.51351 2.13494 1.73277 1.74467 2.12305C1.35439 2.51333 1.13513 3.04266 1.13513 3.59459V11.9189C1.13513 12.4709 1.35439 13.0002 1.74467 13.3905C2.13494 13.7807 2.66428 14 3.21621 14H10.7838C11.3357 14 11.865 13.7807 12.2553 13.3905C12.6456 13.0002 12.8649 12.4709 12.8649 11.9189V3.59459C12.8649 3.04266 12.6456 2.51333 12.2553 2.12305C11.865 1.73277 11.3357 1.51351 10.7838 1.51351ZM3.21621 2.64865H4.16216V3.59459C4.16216 3.74512 4.22196 3.88949 4.3284 3.99593C4.43484 4.10237 4.5792 4.16216 4.72973 4.16216C4.88025 4.16216 5.02462 4.10237 5.13106 3.99593C5.2375 3.88949 5.29729 3.74512 5.29729 3.59459V2.64865H8.7027V3.59459C8.7027 3.74512 8.7625 3.88949 8.86894 3.99593C8.97538 4.10237 9.11974 4.16216 9.27027 4.16216C9.42079 4.16216 9.56516 4.10237 9.6716 3.99593C9.77804 3.88949 9.83783 3.74512 9.83783 3.59459V2.64865H10.7838C11.0347 2.64865 11.2753 2.74831 11.4527 2.92571C11.6301 3.10311 11.7297 3.34371 11.7297 3.59459V5.67568H2.27027V3.59459C2.27027 3.34371 2.36993 3.10311 2.54733 2.92571C2.72473 2.74831 2.96533 2.64865 3.21621 2.64865ZM10.7838 12.8649H3.21621C2.96533 12.8649 2.72473 12.7652 2.54733 12.5878C2.36993 12.4104 2.27027 12.1698 2.27027 11.9189V6.81081H11.7297V11.9189C11.7297 12.1698 11.6301 12.4104 11.4527 12.5878C11.2753 12.7652 11.0347 12.8649 10.7838 12.8649Z"
        fill="currentColor"
      ></path>
    </svg>
    @if(showClear && inputValue) {
    <svg
      (click)="onClear()"
      class="clear-icon"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M8.01186 7.00933L12.27 2.75116C12.341 2.68501 12.398 2.60524 12.4375 2.51661C12.4769 2.42798 12.4982 2.3323 12.4999 2.23529C12.5016 2.13827 12.4838 2.0419 12.4474 1.95194C12.4111 1.86197 12.357 1.78024 12.2884 1.71163C12.2198 1.64302 12.138 1.58893 12.0481 1.55259C11.9581 1.51625 11.8617 1.4984 11.7647 1.50011C11.6677 1.50182 11.572 1.52306 11.4834 1.56255C11.3948 1.60204 11.315 1.65898 11.2488 1.72997L6.99067 5.98814L2.7325 1.72997C2.59553 1.60234 2.41437 1.53286 2.22718 1.53616C2.03999 1.53946 1.8614 1.61529 1.72901 1.74767C1.59663 1.88006 1.5208 2.05865 1.5175 2.24584C1.5142 2.43303 1.58368 2.61419 1.71131 2.75116L5.96948 7.00933L1.71131 11.2675C1.576 11.403 1.5 11.5866 1.5 11.7781C1.5 11.9696 1.576 12.1532 1.71131 12.2887C1.84679 12.424 2.03043 12.5 2.2219 12.5C2.41338 12.5 2.59702 12.424 2.7325 12.2887L6.99067 8.03052L11.2488 12.2887C11.3843 12.424 11.568 12.5 11.7594 12.5C11.9509 12.5 12.1346 12.424 12.27 12.2887C12.4053 12.1532 12.4813 11.9696 12.4813 11.7781C12.4813 11.5866 12.4053 11.403 12.27 11.2675L8.01186 7.00933Z"
        fill="#5D6983"
      ></path>
    </svg>
    }
  </div>
  @if(dateControl.hasError('endDateRequired') && !popoverOpened) {
  <div class="form-control-error-message">End date is required</div>
  }
  <div #datePickerWrapper style="position: relative"></div>
  <p-popover
    #op
    [appendTo]="datePickerWrapper"
    [dismissable]="true"
    (onShow)="onPopoverShow()"
    (onHide)="popoverOpened = false"
  >
    <div class="popover-content">
      <div class="popover-left-content">
        <ul class="period-list">
          @for (item of listOptions; track item.key) {
          <!--          <li-->
          <!--            [ngClass]="{-->
          <!--              'selected-item': currentAlias === item.key-->
          <!--            }"-->
          <!--            (click)="onListSelect(item.key)"-->
          <!--          >-->
          <!--            <span>{{ item.value }}</span>-->
          <!--          </li>-->
          <li
            [ngClass]="{
              'selected-item':
                currentAlias === item.key && currentAlias !== 'custom'
            }"
            (click)="onListSelect(item.key)"
          >
            <span>{{ item.value }}</span>
          </li>
          }
        </ul>
      </div>
      <div class="popover-right-content">
        <p-datepicker
          selectionMode="range"
          [firstDayOfWeek]="1"
          [formControl]="dateControl"
          [inline]="true"
          [minDate]="$any(minDate)"
          [maxDate]="$any(maxDate)"
          [showTime]="showTimePicker"
          (onSelect)="dateSelection()"
        ></p-datepicker>
      </div>
    </div>
  </p-popover>
</div>
